import UIComponent from "../../common/UIComponent";
import "./index.css";

/**
 * 播放时间/整体时间元素组件，仅用于点播
 */
export default class CurrentTime extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();

    this.interfaces.on(VhallPlayer.LOADED, () => {
      // todo: display?
      // this.timeBox.style.display = "none";
      const second = this.interfaces.getDuration() ;
      this.allTime.innerText = this._secondToDate(second);
    })

    this.interfaces.on(VhallPlayer.TIMEUPDATE, () => {
      const second = this.interfaces.getCurrentTime();
      this.currentTime.innerText = this._secondToDate(second);
    })
  }

  init() {
    this.timeBox = document.createElement("div");
    // this.timeBox.style.display = "none";
    this.timeBox.setAttribute("class", "vhallPlayer-time-box");

    // 当前时间
    this.currentTime = document.createElement("span");
    this.currentTime.setAttribute("class", "current-time");
    this.currentTime.innerText = "00:00:00";

    // 分割线
    this.cutLine = document.createElement("i");
    this.cutLine.innerText = "/";

    // 所有时间
    this.allTime = document.createElement("span");
    this.allTime.setAttribute("class", "all-time");
    this.allTime.innerText = "00:00:00";

    this.timeBox.appendChild(this.currentTime);
    this.timeBox.appendChild(this.cutLine);
    this.timeBox.appendChild(this.allTime);

    this.insertElement(this.elementId, this.timeBox);
  }

  _secondToDate(result) {
    var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
    var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
    return result = h + ":" + m + ":" + s;
  }
}